// Make selected links open in new tab
// Add the target attr to those that don't have it
$.each($("a"), function (index, link) {
    const isTel = link.href.startsWith("tel:"); // Don't want to add to mail links
    const isMailTo = link.href.startsWith("mailto:"); // Don't want to add to mail links
    const isInternalLink = link.href.startsWith(location.origin); // Internal link if it starts with local URL eg.http://localhost:3000 or http://buy-app-staging.bikmo.com/
    if (!isInternalLink && !isMailTo && !isTel) {
        $(link).attr("target", "_blank");
    }
});